import React from 'react';
import ReactDOM from 'react-dom';
import { createBrowserHistory } from 'history';
import { Router, Route, Switch, Link } from 'react-router-dom';

import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import { createLogger } from 'redux-logger';
import thunk from 'redux-thunk';

import LeftSidebar from 'components/LeftSidebar';

import { withPreview } from 'HOC';

import reducer from './reducers'
import { routes } from './routes';

import ParentComponent from './parentComponent';

import 'bootstrap/dist/css/bootstrap.min.css';

import LoginView from "./views/Login";

import 'react-virtualized/styles.css'

import '@atlaskit/css-reset';

import './index.css'

const hist = createBrowserHistory();

const middleware = [ thunk ];
if (process.env.NODE_ENV !== 'production') {
  // middleware.push(createLogger());
}

const storeWithMiddleware = applyMiddleware(...middleware)(createStore);
const store = storeWithMiddleware(reducer);

ReactDOM.render(
  <Provider store={store}>
    <Router history={hist}>
      <Switch>
        <Route
          path={'/'}
          exact={true}
          component={LoginView}
        />
        <ParentComponent/>
      </Switch>
    </Router>
  </Provider>,
  document.getElementById("root")
);
